export default function Card(theme) {
  const paddingXS = 1.5;
  const paddingSM = 2;
  const paddingMD = 3;
  const paddingLG = 4;

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          // zIndex: 0, // Fix Safari overflow: hidden with border radius
          overflow: 'visible',

          // Mobile
          // boxShadow: theme.shadows[4],
          // border: 0,
          // borderRadius: 0,
          // backgroundColor: theme.palette.background.paper,

          // Tablet & desktop
          [theme.breakpoints.up('sm')]: {
            // border: '1px solid rgba(0, 0, 0, 6%)',
            // borderRadius: 16
          },

          // Pas d'ombre si variant = outlined
          '&.MuiPaper-outlined': {
            // boxShadow: 'none'
          }
        }
      }
    },

    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          // variant: 'subtitle1'
        },
        subheaderTypographyProps: {
          // variant: 'body2'
          // marginTop: theme.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          flexWrap: 'wrap',
          gap: theme.spacing(1.5),
          overflowWrap: 'anywhere',
          cursor: 'default',
          padding: theme.spacing(paddingXS, paddingXS, 0, paddingXS),
          [theme.breakpoints.up('sm')]: { padding: theme.spacing(paddingSM, paddingSM, 0, paddingSM) },
          [theme.breakpoints.up('md')]: { padding: theme.spacing(paddingSM, paddingMD, 0, paddingMD) },
          [theme.breakpoints.up('lg')]: { padding: theme.spacing(paddingMD, paddingLG, 0, paddingLG) },
          UserSelect: 'none !important',

          '.MuiCardHeader-content > span': {
            display: 'flex',
            gap: theme.spacing(1) // Required for Chip to be added next to card header title
          },

          '.MuiCardHeader-action': {
            margin: 0
          }
        }
      }
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          flexGrow: 1,
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: theme.spacing(paddingXS),
          [theme.breakpoints.up('sm')]: { padding: theme.spacing(paddingSM) },
          [theme.breakpoints.up('md')]: { padding: theme.spacing(paddingMD) },
          [theme.breakpoints.up('lg')]: { padding: theme.spacing(paddingLG) }
        }
      }
    },

    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(paddingXS),
          paddingTop: 0,
          [theme.breakpoints.up('sm')]: { padding: theme.spacing(paddingSM), paddingTop: 0 },
          [theme.breakpoints.up('md')]: { padding: theme.spacing(paddingMD), paddingTop: 0 },
          [theme.breakpoints.up('lg')]: { padding: theme.spacing(paddingLG), paddingTop: 0 }
        }
      }
    }
  };
}
